import { size } from "polished";
import styled from "styled-components";
import i18n from "../../i18n";
import BaseNewIcon from "../../img/icons/new.svg?react";
import BaseSameIconLTR from "../../img/icons/same-ltr.svg?react";
import BaseSameIconRTL from "../../img/icons/same-rtl.svg?react";
import { isRTL } from "../../utils/locale";

export const NewIcon = styled(BaseNewIcon)`
  ${size(12)}
  fill: grey;
`;

export const SameIcon = isRTL(i18n.language)
  ? styled(BaseSameIconRTL)`
      ${size(10)}
      fill: grey;
    `
  : styled(BaseSameIconLTR)`
      ${size(10)}
      fill: grey;
    `;
